(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["checkout-like-a-mutha"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('checkout-like-a-mutha')) {
    /**
     * Check Out Like A MUTHA page behavior:
     * - re-picks the offer bar message by the shop's local date (cached pages flip on time)
     * - shows the mobile sticky buy bar once the hero boxes scroll away, hides it over the bottom CTA
     */
    class CheckoutLikeAMutha extends HTMLElement {
      connectedCallback() {
        this.updateOffer();
        this.setupSticky();
      }

      disconnectedCallback() {
        this.heroObserver?.disconnect();
        this.chooseObserver?.disconnect();
      }

      /** @returns {number | null} Today as YYYYMMDD in the configured time zone. */
      todayNumber() {
        try {
          const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: this.dataset.timezone || 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).formatToParts(new Date());
          const get = (type) => parts.find((part) => part.type === type)?.value ?? '';
          return Number(`${get('year')}${get('month')}${get('day')}`);
        } catch {
          return null;
        }
      }

      updateOffer() {
        const bar = this.querySelector('[data-clm-offer]');
        if (!bar) return;
        const today = this.todayNumber();
        if (!today) return;

        const messages = bar.querySelectorAll('[data-clm-offer-start]');
        const fallback = bar.querySelector('[data-clm-offer-default]');
        let active = null;
        for (const message of messages) {
          const start = Number(message.getAttribute('data-clm-offer-start'));
          const end = Number(message.getAttribute('data-clm-offer-end'));
          if (!active && start && end && today >= start && today <= end) active = message;
        }
        for (const message of messages) message.hidden = message !== active;
        if (fallback) fallback.hidden = Boolean(active);
      }

      setupSticky() {
        const sticky = this.querySelector('[data-clm-sticky]');
        const hero = this.querySelector('[data-clm-hero-boxes]');
        if (!sticky || !hero || !('IntersectionObserver' in window)) return;

        const choose = this.querySelector('[data-clm-choose]');
        let heroGone = false;
        let atChoose = false;
        const apply = () => {
          const show = heroGone && !atChoose;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', String(!show));
          sticky.inert = !show;
        };

        this.heroObserver = new IntersectionObserver(([entry]) => {
          heroGone = !entry.isIntersecting;
          apply();
        });
        this.heroObserver.observe(hero);

        if (choose) {
          this.chooseObserver = new IntersectionObserver(([entry]) => {
            atChoose = entry.isIntersecting;
            apply();
          });
          this.chooseObserver.observe(choose);
        }
      }
    }

    customElements.define('checkout-like-a-mutha', CheckoutLikeAMutha);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
